import { createSlice } from "@reduxjs/toolkit";


const highVolumeSlice = createSlice({
    name: "highVolume",
    initialState: {
        showExportToast: false,
        highVolumeGeneratingReport: false,
        exportJobs: [], // Array of { jobId, fileName, status, downloadUrl }
    },
    reducers: {
        setShowExportToast(state, action) {
            state.showExportToast = action.payload;
        },
        setHighVolumeGeneratingReport(state, action) {
            state.highVolumeGeneratingReport = action.payload;
        },
        addExportJob(state, action) {
            // Add new job: { jobId, fileName, status: 'progress' }
            state.exportJobs.push(action.payload);
            state.exportJobs.reverse();
                 },
        updateExportJob(state, action) {
            // Update existing job by jobId
            const { jobId, ...updates } = action.payload;
            const jobIndex = state.exportJobs.findIndex(job => job.jobId === jobId);
            if (jobIndex !== -1) {
                state.exportJobs[jobIndex] = { ...state.exportJobs[jobIndex], ...updates };
            }
        },
        removeExportJob(state, action) {
            // Remove job by jobId
            state.exportJobs = state.exportJobs.filter(job => job.jobId !== action.payload);
        },
        clearCompletedExportJobs(state) {
            // Remove all completed or failed jobs
            state.exportJobs = state.exportJobs.filter(
                job => job.status === 'progress'
            );
        }
    },
});

export const {
    setShowExportToast,
    setHighVolumeGeneratingReport,
    addExportJob,
    updateExportJob,
    removeExportJob,
    clearCompletedExportJobs
} = highVolumeSlice.actions;

export default highVolumeSlice.reducer;